// Socket actions constants
export const SOCKET = {
  online: 'online',
  newFeed: 'newFeed',
  timerStarted: 'timerStarted',
  timerStopped: 'timerStopped',
  eventModerateCount: 'eventModerateCount',
  credentialModerateCount: 'credentialModerateCount',
  taskChanges: 'taskChanges',
};
